import React, { ReactElement } from 'react'
import {
  Box,
  VStack,
  Text,
  Button,
  HStack,
  Spacer,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { SearchType } from '../../pages/discover'

const searchTypes: SearchType[] = ['all', 'dashboards', 'users']

interface Props {
  onSelect: (type: SearchType) => void
  value: SearchType
  isMobile: boolean
}

function labelForSearchType(type: SearchType): string {
  switch (type) {
    case 'all':
      return 'All'
    case 'dashboards':
      return 'Dashboards'
    case 'users':
      return 'Users'
  }
}

const SearchTypeSelect = ({
  onSelect,
  value,
  isMobile,
}: Props): ReactElement => {
  return (
    <Popover gutter={18} placement="bottom" matchWidth={true}>
      {({ onClose }) => (
        <>
          {isMobile && (
            <Text fontWeight="semibold" mb={2}>
              Search across
            </Text>
          )}
          <PopoverTrigger>
            <Button
              verticalAlign="center"
              variant="unstyled"
              w="inherit"
              minW="inherit"
              borderWidth={'thin'}
              borderStyle={isMobile ? 'solid' : 'none'}
              borderColor={'gray.200'}
            >
              <HStack align="center" w="inherit" minW="inherit" pr={4}>
                <Text fontWeight={isMobile ? 'normal' : 'medium'} pl={3}>
                  {labelForSearchType(value)}
                </Text>
                <Spacer />
                <ChevronDownIcon
                  pos="absolute"
                  boxSize="1.2rem"
                  right={isMobile ? 2 : 0}
                />
              </HStack>
            </Button>
          </PopoverTrigger>
          <PopoverContent transitionDuration="0s" w="inherit" minW="inherit">
            <PopoverBody borderRadius="md" p={0} w="inherit" minW="inherit">
              <VStack align="stretch" spacing={0}>
                {searchTypes.map((type) => (
                  <Box
                    px={3}
                    py={2}
                    key={type}
                    onClick={() => {
                      onClose()
                      setTimeout(() => onSelect(type), 100)
                    }}
                    _hover={{ bg: 'gray.200', cursor: 'pointer' }}
                  >
                    {type === value && (
                      <Text as="b">{labelForSearchType(type)}</Text>
                    )}
                    {type !== value && labelForSearchType(type)}
                  </Box>
                ))}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}

export default SearchTypeSelect

// const SearchTypeSelect = ({
//   onSelect,
//   value,
// }: SearchTypeSelectProps): ReactElement => {
//   return (
//     <Menu autoSelect={false} gutter={20} placement="bottom" matchWidth={true}>
//       <MenuButton w="16rem">
//         <HStack align="center" pl={2.5} pr={4} w="100%">
//           <Text as="b">{labelForSearchType(value)}</Text>
//           <Spacer />
//           <ChevronDownIcon boxSize="1.2rem" />
//         </HStack>
//       </MenuButton>
//       <MenuList minW="inherit">
//         {searchTypes.map((type, idx) => (
//           <MenuItem key={idx} onClick={() => onSelect(type)}>
//             {type === value && <Text as="b">{labelForSearchType(type)}</Text>}
//             {type !== value && labelForSearchType(type)}
//           </MenuItem>
//         ))}
//       </MenuList>
//     </Menu>
//   )
// }
